import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { Router } from '@angular/router';
import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';

@Component({
  selector: 'app-not-found',
  imports: [HlmButtonDirective],
  standalone: true,
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  private readonly location = inject(Location);
  private readonly router = inject(Router);

  protected goBack() {
    this.location.back();
  }

  protected goHome() {
    this.router.navigate([PAGE_ROUTES.HOME]);
  }
}
